export default __webpack_public_path__ + "static/media/options.317c9d08.svg";